export default {
  title: 'Scene',
  playTitle: 'Gameplay Template',
  deleteSceneConfirm: 'Whether to delete the scene?',
  deletePlaySceneConfirm: {
    title: 'Confirm to delete the game template? ',
    rule1:
      '· Delete the game template, and the scenes bound in the game template will also be deleted. If you want to retain the content of the scene, please unbind the scene from the play template before deleting the play template.',
    rule2: '· This operation is not recoverable, please confirm.',
    rule3:
      '· Deleting the last gameplay template will automatically return to the project editing page.',
  },
  deleteSceneWarning: 'Warn',
  confirm: 'Confirm',
  cancel: 'Cancel',
  newScene: 'Create new Scene',
  copyScene: 'Duplicate the Scene',
  renameScene: 'Rename',
  deleteScene: 'Delete scene',
  newAndSave: 'Save as Preset',
  saveSuccess: 'Save Success',
  deleteSceneError: 'At least one scene is required',
  newPlayScene: 'Create new play scene',
  deletePlayScene: 'Delete play scene',
}
